<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :rules="rules"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="拣货下架固定暂存位："
              prop="temporaryStorehouse"
            >
              <el-select
                v-model="formData.temporaryStorehouse"
                placeholder="请选择"
                filterable
                :disabled="isDetail || warehouseFoundation.disabled"
              >
                <el-option
                  v-for="item in warehouseFoundation.option"
                  :key="item.locationCode"
                  :label="item.locationCode"
                  :value="item.locationCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <prescription
              :time.sync="formData.executeMaxTime"
              :time-type.sync="formData.timeUnit"
              :disabled="isDetail"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="语音拣选规则："
              prop="ruleVoiceConfig"
            >
              <el-select
                v-model="formData.ruleVoiceConfig"
                clearable
                placeholder="请选择"
                value-key="id"
                filterable
                :disabled="isDetail"
              >
                <el-option
                  v-for="item in ruleVoiceConfig"
                  :key="item.id"
                  :label="item.ruleName"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="是否打印门店标签："
              prop="printStationTag"
            >
              <el-radio-group
                v-model="formData.printStationTag"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in useGatherGoodsPlace"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="5"
          :table-data="formData.ruleFlowTaskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import { tempStoreHouse, voiceConfigList } from '@/api/configure/warehousingProcess';
import Prescription from '../../components/Prescription.vue';
import TaskSetting from './TaskSetting.vue';
import { WAVE_GROUP_OPTIONS, NODE_TYPE, useGatherGoodsPlace } from './constant';

export default {
  components: {
    ListBlock,
    Prescription,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    warehouseId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      WAVE_GROUP_OPTIONS,
      useGatherGoodsPlace,
      rules: {
        temporaryStorehouse: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        printStationTag: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
      warehouseFoundation: {
        disabled: false,
        option: [],
      },
      ruleVoiceConfig: [],
    };
  },
  watch: {
    warehouseId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal) {
          this.formData.temporaryStorehouse = null;
        }
        if (newVal) {
          this.warehouseFoundation = {
            disabled: false,
            option: [],
          };
          this.getStoreHouse();
        }
      },
    },
  },
  created() {
    this.getVoiceConfigList();
  },
  methods: {
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(5);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[5].label}”节点数据`);
        }
      });
    },
    async getStoreHouse() {
      const res = await tempStoreHouse({
        warehouseId: this.warehouseId,
        typeCode: 'VIRTUAL_GOODS_AREA',
      }) || [];

      this.warehouseFoundation.option = res;
      if (!this.formData.temporaryStorehouse) {
        const defaultVal = res.find((item) => item.isDefault);
        if (defaultVal) {
          this.formData.temporaryStorehouse = defaultVal.locationCode;
        }
      }
    },
    async getVoiceConfigList() {
      this.ruleVoiceConfig = await voiceConfigList({}) || [];
    },
  },
};
</script>
